import Permission from "../../permission";

export default class BulkPermissionCommand {
  public readonly resources: string[];
  public readonly granteeUserId: string;
  public readonly note?: string;

  public constructor(permissions: Permission[]) {
    const firstGranteeUserId = permissions[0].granteeUserId;
    const firstNote = permissions[0].note;

    const allSameGranteeUserId = permissions.every(p => p.granteeUserId === firstGranteeUserId);
    const allSameNote = permissions.every(p => p.note === firstNote);

    if (!allSameGranteeUserId || !allSameNote) {
      throw new Error("All permissions must have the same granteeUserId and note.");
    }

    this.resources = permissions.map(p => JSON.stringify(p.resource?.toJSON()));
    this.granteeUserId = firstGranteeUserId?.value;
    this.note = firstNote;
  }
}
